
import Inspection from "./Inspection.js";
import { SubDomain } from "../SubDomain.js";

export default class InspectionsDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, Inspection.MODEL_NAME);
    this.storage = storage;
  }

  hasFilter(filter) {
    if (filter) {
      //
    }
    return false;
  }

  list() {
    return this.storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new Inspection(this.domain, item);
      }
    }

    return new Inspection(this.domain);
  }

  findByVehicle(vehicle) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = new Inspection(this.domain, objects[i]);
      if (item.vehicle().idEquals(vehicle)) {
        return item;
      }
    }

    return new Inspection(this.domain);
  }
}